export const VirtualAdsFormModal = () =>
  import("@virtualAds/components/modals/VirtualAdsFormModal.vue");

export default { VirtualAdsFormModal };
